/**
 * Typed route builders - auto-generated from routeTree.gen.ts
 *
 * DO NOT EDIT MANUALLY - this file is generated automatically by scripts/generate-routes.mjs
 * Routes are derived from the file-based routing structure (src/pages directory).
 * Edit route definitions by adding/moving/deleting files, not by editing this file.
 */

export const routes = {
  accountnotlinked: () => "/account-not-linked" as const,
  admin: {
    users: {
      home: () => "/admin/users" as const,
      user: () => ({
        home: () => "/admin/users/$userId" as const,
        statistics: () => "/admin/users/$userId/statistics" as const,
        tasks: () => "/admin/users/$userId/tasks" as const,
      }),
    },
  },
  dashboard: () => "/dashboard" as const,
  dev: {
    dashboard: () => "/dev/dashboard" as const,
  },
  diagram: {
    diagram: () => "/diagram/$diagramId" as const,
  },
  engineering: {
    materialfunctions: () => "/engineering/material-functions" as const,
    materials: {
      home: () => "/engineering/materials" as const,
      functions: () => "/engineering/materials/functions" as const,
      material: () => ({
        home: () => "/engineering/materials/$materialId" as const,
        composition: () => "/engineering/materials/$materialId/composition" as const,
        descriptions: () => "/engineering/materials/$materialId/descriptions" as const,
        notes: () => "/engineering/materials/$materialId/notes" as const,
        offers: () => "/engineering/materials/$materialId/offers" as const,
      }),
    },
    services: {
      home: () => "/engineering/services" as const,
      functions: () => "/engineering/services/functions" as const,
      service: () => ({
        home: () => "/engineering/services/$serviceId" as const,
        composition: () => "/engineering/services/$serviceId/composition" as const,
        descriptions: () => "/engineering/services/$serviceId/descriptions" as const,
        notes: () => "/engineering/services/$serviceId/notes" as const,
        offers: () => "/engineering/services/$serviceId/offers" as const,
      }),
    },
    suppliers: {
      home: () => "/engineering/suppliers" as const,
      functions: () => "/engineering/suppliers/functions" as const,
      supplier: () => ({
        home: () => "/engineering/suppliers/$supplierId" as const,
        contacts: () => "/engineering/suppliers/$supplierId/contacts" as const,
        notes: () => "/engineering/suppliers/$supplierId/notes" as const,
        offers: () => "/engineering/suppliers/$supplierId/offers" as const,
      }),
    },
  },
  login: () => "/login" as const,
  sales: {
    clients: {
      home: () => "/sales/clients" as const,
      client: () => ({
        home: () => "/sales/clients/$clientId" as const,
        contacts: () => "/sales/clients/$clientId/contacts" as const,
        notes: () => "/sales/clients/$clientId/notes" as const,
      }),
    },
    expedients: {
      home: () => "/sales/expedients" as const,
      expedient: () => ({
        home: () => "/sales/expedients/$expedientId" as const,
        notes: () => "/sales/expedients/$expedientId/notes" as const,
        offers: () => "/sales/expedients/$expedientId/offers" as const,
        options: () => "/sales/expedients/$expedientId/options" as const,
      }),
    },
    leads: {
      home: () => "/sales/leads" as const,
      lead: () => ({
        home: () => "/sales/leads/$leadId" as const,
        contacts: () => "/sales/leads/$leadId/contacts" as const,
        notes: () => "/sales/leads/$leadId/notes" as const,
      }),
    },
    offers: {
      home: () => "/sales/offers" as const,
      editor: {
        customerOffer: () => "/sales/offers/editor/$customerOfferId" as const,
      },
      offer: () => ({
        home: () => "/sales/offers/$offerId" as const,
        details: () => "/sales/offers/$offerId/details" as const,
        editor: () => "/sales/offers/$offerId/editor" as const,
        history: () => "/sales/offers/$offerId/history" as const,
        notes: () => "/sales/offers/$offerId/notes" as const,
        preview: () => "/sales/offers/$offerId/preview" as const,
      }),
      templates: {
        home: () => "/sales/offers/templates" as const,
        editor: {
          offerTemplate: () => "/sales/offers/templates/editor/$offerTemplateId" as const,
        },
        offerTemplate: () => ({
          home: () => "/sales/offers/templates/$offerTemplateId" as const,
          details: () => "/sales/offers/templates/$offerTemplateId/details" as const,
          editor: () => "/sales/offers/templates/$offerTemplateId/editor" as const,
          notes: () => "/sales/offers/templates/$offerTemplateId/notes" as const,
          preview: () => "/sales/offers/templates/$offerTemplateId/preview" as const,
        }),
      },
    },
    offertemplates: () => "/sales/offer-templates" as const,
    representatives: {
      home: () => "/sales/representatives" as const,
      representative: () => ({
        home: () => "/sales/representatives/$representativeId" as const,
        commissions: () => "/sales/representatives/$representativeId/commissions" as const,
        contacts: () => "/sales/representatives/$representativeId/contacts" as const,
        notes: () => "/sales/representatives/$representativeId/notes" as const,
      }),
    },
  },
  settings: () => "/settings" as const,
  signedout: () => "/signed-out" as const,
  usermanagement: {
    users: {
      home: () => "/user-management/users" as const,
      roles: {
        home: () => "/user-management/users/roles" as const,
        role: () => ({
          home: () => "/user-management/users/roles/$roleId" as const,
          permissions: () => "/user-management/users/roles/$roleId/permissions" as const,
        }),
      },
      user: () => ({
        home: () => "/user-management/users/$userId" as const,
        permissions: () => "/user-management/users/$userId/permissions" as const,
        roles: () => "/user-management/users/$userId/roles" as const,
      }),
    },
  },
} as const;
